import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

export const daysTH = () => {
    return ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"];
}

export const monthsTH = () => {
    return ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
}

export const isEmpty = (data) => {
    return (data === undefined || data === null || data === "");
}

export const formatNumber = (num, minDecimals = 2, maxDecimals = 2) => {
    const n = Number(num);
    if (isNaN(n)) return '0.00';
    return n.toLocaleString('en-US', { minimumFractionDigits: minDecimals, maximumFractionDigits: maxDecimals });
}

export const convertFormatDate = (date) => {
    // `getMonth()` is zero-based -- January is 0 and December is 11 -- and
    // the +1 was missing, so every date this produced was a month early.
    // December printed as "11", and the string "-12-" could never appear
    // at all. It reaches the sale receipt, the goods-receive and purchase
    // order documents, the PO list and exported file names, so a customer
    // holding a receipt dated 2026-12-25 was reading 2026-11-25.
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export const convertFormatDateTime = (date, isISO) => {
    return convertFormatDate(date) 
        + (isISO ? 'T' : ' ')
        + (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) 
        + ':' + (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) 
        + ':' + (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
}

export const exportExcel = (name, data) => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType : 'xlsx', type: 'array' });
    const file = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(file, name + '-' + convertFormatDateTime(new Date()).replaceAll(' ', '-').replaceAll(':', '-') + fileExtension);
}

export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

export const validateEmail = (value) => {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (!value.match(validRegex)) {
        return false;
    } 

    return true;
}

export const getToken = () => {
    // chrome://flags/#enable-webrtc-hide-local-ips-with-mdns
    return new Promise(function(resolve) {
        var RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
    
        if (!RTCPeerConnection) {
            resolve('127.0.0.1');
            return;
        }
        
        try {
            var rtc = new RTCPeerConnection({iceServers:[]});
            
            function grepSDP(sdp) {
                var finalIP = '';
                var parts, addr, type;
                sdp.split('\r\n').forEach(function (line) { 
                    if (~line.indexOf("a=candidate")) {
                        parts = line.split(' ');
                        addr = parts[4];
                        type = parts[7];
                        if (type === 'host') {
                            finalIP = addr;
                        }
                    } else if (~line.indexOf("c=")) {
                        parts = line.split(' ');
                        addr = parts[2];
                        finalIP = addr;
                    }
                });
                return finalIP;
            }
            
            rtc.createDataChannel('', {reliable:false});
            
            rtc.onicecandidate = function (evt) {
                if (evt && evt.candidate) {
                    var addr = grepSDP("a="+evt.candidate.candidate);
                    resolve(addr || '127.0.0.1');
                }
            };

            rtc.createOffer(function (offerDesc) {
                rtc.setLocalDescription(offerDesc);
            }, function (e) { 
                console.warn("offer failed", e);
                resolve('127.0.0.1');
            });
        } catch (err) {
            resolve('127.0.0.1');
        }
    });
}